<template>
    <el-form :model="giftBagSetting"
             v-form
             editAction="dbtCard/saveRightsCardInfo.action"
             addAction= "dbtCard/saveRightsCardInfo.action"
             selectAction="dbtCard/selectRightsCardInfo.action"
             @onAdded="onSaved"
             @onEdited="onSaved"
             :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm">

        <el-form-item label="会员名称" prop="name">
            <el-input v-model="giftBagSetting.name" placeholder="请输入会员名称"></el-input>
        </el-form-item>
        <el-form-item label="会员介绍" prop="cardDesc">
            <el-input v-model="giftBagSetting.cardDesc" placeholder="请输入会员介绍"></el-input>
        </el-form-item>

        <el-form-item label="上传介绍图" prop="contentImg">
            <el-upload :http-request="onHttpRequest" accept="image/*" :on-success="uploadSuccess1"  class="avatar-uploader" v-model="giftBagSetting.contentImg" action="upload/uploadPic" :show-file-list="false" :data="{floder:'vipCardConfig'}"  >
                <img v-if="giftBagSetting.showContentImg" :src="giftBagSetting.showContentImg" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>

        </el-form-item>

        <el-form-item label="有效期" prop="effectiveDays">
            <el-select v-model="giftBagSetting.effectiveDays" placeholder="请选择">
                <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="会员价格" prop="retailPrice">
            <el-input v-model="giftBagSetting.retailPrice" step="0.01" type="number" placeholder="请输入价格"></el-input>
        </el-form-item>
        <el-form-item label="经纪人奖励" prop="agentRewardMoney">
            <el-input v-model="giftBagSetting.agentRewardMoney" step="0.01" type="number" placeholder="请输入价格"></el-input>
        </el-form-item>
        <el-form-item label="合伙人奖励" prop="dealerRewardMoney">
            <el-input v-model="giftBagSetting.dealerRewardMoney" step="0.01" type="number" placeholder="请输入价格"></el-input>
            <br>
            若合伙人直拓，则获得经纪人奖励+合伙人奖励
        </el-form-item>
       <!-- <el-form-item label="经纪人购买价" prop="agentPurchasePrice">
            <el-input v-model="giftBagSetting.agentPurchasePrice" step="0.01" type="number" placeholder="请输入经纪人充值价"></el-input>
        </el-form-item>
        <el-form-item label="经纪人最低购买量" prop="agentBuyMixNum">
            <el-input v-model.number="giftBagSetting.agentBuyMixNum" type="number" min="1" placeholder="请输入经纪人最低购买量"></el-input>
        </el-form-item>
        <el-form-item label="合伙人购买价" prop="dealerPurchasePrice">
            <el-input v-model="giftBagSetting.dealerPurchasePrice" type="number" step="0.01" placeholder="请输入合伙人购买价"></el-input>
        </el-form-item>
        <el-form-item label="合伙人最低购买量" prop="dealerBuyMixNum">
            <el-input v-model.number="giftBagSetting.dealerBuyMixNum" type="number" min="1" placeholder="请输入合伙人最低购买量"></el-input>
        </el-form-item>-->
        <el-form-item>
            <el-button type="primary" >立即保存</el-button>
        </el-form-item>
    </el-form>
</template>
<script>

import Config from '@/framework/configs/Config'
import BasicPager from '@/mixins/BasicPager'
import TableTemplate from '@/components/TableTemplate'
export default {
  name: 'gift-bag-setting',
  extends: BasicPager,
  components: { TableTemplate },
  data () {
    let checkInt = (rule, value, callback) => {
      if (value < 1) {
        return callback(new Error('请填写大于1的数值'))
      }

      let match = (value + '').match(/^\d+(\.\d{0})?$/)
      if (!match) {
        return callback(new Error('只能为整数哦！'))
      }

      callback()
    }

    let checkDecimal = (rule, value, callback) => {
      if (value < 0.01) {
        return callback(new Error('请填写大于0.01的数值'))
      }

      let match = (value + '').match(/^\d+(\.\d{1,2})?$/)
      if (!match) {
        return callback(new Error('小数点只能保留两位哦！'))
      }
      callback()
    }
    let checkRewardMoney = (rule, value, callback) => {
      let match = (value + '').match(/^\d+(\.\d{1,2})?$/)
      if (!match) {
        return callback(new Error('小数点只能保留两位哦！'))
      }

      let retailPrice = parseFloat(this.giftBagSetting.retailPrice)
      if (value > retailPrice) {
        return callback(new Error('价格不能大于会员价'))
      }
      callback()
    }

    return {
      baseUrl: Config.baseUrl,
      imageUrl: Config.imageUrl,
      options: [{
        value: 365,
        label: '购买后365天内有效'
      }],
      giftBagSetting: {
        id: 1,
        name: null,
        cardDesc: null,
        retailPrice: null,
        contentImg: null,
        showContentImg: null,
        agentPurchasePrice: 0,
        agentBuyMixNum: null,
        dealerPurchasePrice: 0,
        dealerBuyMixNum: null,
        effectiveDays: 365,
        agentRewardMoney: null,
        dealerRewardMoney: null

      },
      rules: {
        name: [
          { required: true, message: '请输入会员名称', trigger: 'blur' }
        ],
        cardDesc: [
          { required: true, message: '请输入会员介绍', trigger: 'blur' }
        ],
        retailPrice: [
          { required: true, message: '请输入会员价格', trigger: 'blur' }
        ],
        agentRewardMoney: [
          { required: true, message: '请输入经纪人奖励价格', trigger: 'blur' },
          { validator: checkRewardMoney, trigger: 'blur' }
        ],
        dealerRewardMoney: [
          { required: true, message: '请输入合伙人奖励价格', trigger: 'blur' },
          { validator: checkRewardMoney, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    uploadSuccess1: function (data) {
      this.giftBagSetting.showContentImg = this.imageUrl + data.datas[0]
      this.giftBagSetting.contentImg = data.datas[0]
    },
    onSaved () {
      this.$message({ type: 'success', message: '操作成功！' })
      return true
    },
    onSelectInfo (dataInfo) {
      if (dataInfo.datas) {
        this.disabled = true
      } else {
        this.disabled = false
      }
    }
  }
}
</script>
